(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-creator-rules"]) return;
  try {
    
  (() => {
    const form = document.getElementById('PartnerCreatorRulesForm');
    if (!form) return;

    const params = new URLSearchParams(window.location.search);
    const emailField = form.querySelector('[data-partner-confirmation-email-field]');
    const nameField = form.querySelector('[data-partner-confirmation-name-field]');
    const briefField = form.querySelector('[data-partner-confirmation-brief-field]');
    const emailLabel = document.querySelector('[data-partner-confirmation-email]');
    const briefLabel = document.querySelector('[data-partner-confirmation-brief-version]');
    const missingEmail = form.querySelector('[data-partner-confirmation-missing-email]');
    const submit = form.querySelector('[data-partner-confirmation-submit]');
    const defaultBrief = briefField ? briefField.value : 'Current Brief';

    const email = (params.get('email') || (emailField ? emailField.value : '')).trim();
    const name = (params.get('name') || (nameField ? nameField.value : '')).trim();
    const brief = (params.get('brief') || defaultBrief).trim();

    if (emailField) emailField.value = email;
    if (nameField) nameField.value = name;
    if (briefField) briefField.value = brief;
    if (briefLabel) briefLabel.textContent = brief;

    if (emailLabel) {
      emailLabel.textContent = email || emailLabel.textContent;
      emailLabel.hidden = !email;
    }

    if (submit) submit.disabled = !email;
    if (missingEmail) missingEmail.hidden = Boolean(email);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y1-prelaunch"] && !Shopify.designMode) return;
  try {
    
  const y1Swatches = document.querySelectorAll('[data-y1-swatch]');
  const y1Stage = document.querySelector('[data-y1-stage]');

  y1Swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      y1Swatches.forEach(function (item) {
        item.setAttribute('aria-pressed', 'false');
      });
      swatch.setAttribute('aria-pressed', 'true');
      if (y1Stage) {
        y1Stage.src = swatch.dataset.image;
        y1Stage.alt = swatch.dataset.alt;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
